import { useDialog } from '@mixins/factories';

import { generateArrayFromString } from '@helpers';

export default {
  name: 'PbDashboardJobsSearch',

  props: {
    jobsIds: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [
    useDialog({
      watchHandlerName: 'setSearchFieldFocus',
      dialogProp: 'isVisibleSearch',
    }),
  ],

  data() {
    return {
      ids: [],
      searchStr: '',

      isFocusInSearch: false,
      isMouseOverSearch: false,

      jobsComboboxRef: Symbol('jobsComboboxRef'),
    };
  },

  computed: {
    searchValueValidation() {
      const invalid = this.ids.some(id => Number.isNaN(Number(id)));

      return { invalid, message: invalid ? ['Invalid job number'] : [] };
    },
  },

  watch: {
    jobsIds: {
      handler(ids) {
        this.$set(this, 'ids', ids);
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    document.addEventListener('keyup', this.toggleDialog);
  },

  beforeDestroy() {
    document.addEventListener('keyup', this.toggleDialog);
  },

  methods: {
    search() {
      const idsFromSearchStr = generateArrayFromString(this.searchStr);

      idsFromSearchStr.forEach((id) => {
        if (!this.ids.includes(id)) {
          this.ids.push(id);
        }
      });

      if (this.searchValueValidation.invalid) {
        return;
      }

      this.searchStr = '';

      this.$emit('search', this.ids);
    },

    setSearchFieldFocus(isOpen) {
      if (isOpen) {
        setTimeout(() => this.$refs[this.jobsComboboxRef].focus(), 0);
      }
    },

    toggleDialog(e) {
      if (e.code === 'Escape' && this.isFocusInSearch && this.isVisibleSearch) {
        this.isVisibleSearch = false;
      } else if (e.ctrlKey && e.altKey && e.keyCode === 70) {
        this.isVisibleSearch = !this.isVisibleSearch;
      }
    },
  },
};
